import React from 'react'
import { NavLink, Switch, Redirect, Route } from 'react-router-dom'

import { ACCOUNT_PATH, ACCOUNT_BILLING_PATH } from 'config'
import Profile from './profile'
import Billing from './billing'

const AccountLayout = () => (
  <div className="profile mb-3">
    <div className="row">
      <div className="col-sm-3">
        <ul className="nav nav-pills flex-column mb-sm-0 mb-3">
          <li className="nav-item">
            <NavLink className="nav-link" activeClassName={'active'} to={ ACCOUNT_PATH } exact>Profile</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" activeClassName={'active'} to={ ACCOUNT_BILLING_PATH }>Billing</NavLink>
          </li>
        </ul>
      </div>
      <div className="col-sm-9">
        <Switch>
          <Route component={ Profile } path={ ACCOUNT_PATH } exact />
          <Route component={ Billing } path={ ACCOUNT_BILLING_PATH } />
          <Redirect to={ ACCOUNT_PATH } />
        </Switch>
      </div>
    </div>
  </div>
)

export default AccountLayout



// WEBPACK FOOTER //
// ./src/components/account/layout.js